export default function Footer({ copy }) {
  const [beforeGuideBg, afterGuideBg] = copy.footer.split('GuideBG')

  return (
    <footer className="site-footer">
      <p>
        <strong>Measures of Mankind</strong> {beforeGuideBg}
        <a href="https://www.guidebg.com/" target="_blank" rel="noreferrer">GuideBG</a>
        {afterGuideBg}
      </p>
    </footer>
  )
}
